module.exports = __webpack_public_path__ + "img/coursespecialty1.4bd2436c.jpg";